import { createRoot } from 'react-dom/client';
import './sass/common.scss';
import App from './App';
import { initStore } from './stores/initStore';

initStore();

createRoot(document.getElementById('root')!).render(<App />);
